import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

import { cn } from '@/lib/utils';

import type { CategoriaModulo } from '../modulos.types';
import { ModuleIcon } from './module-icon';

interface CategoryCardProps {
  categoria: CategoriaModulo;
}

/** Tarjeta de categoría en la pantalla de inicio de módulos. */
export function CategoryCard({ categoria }: CategoryCardProps) {
  return (
    <Link
      to={`/inicio/${categoria.codigo}`}
      className={cn(
        'group relative flex flex-col rounded-card border border-ink-100 bg-white p-5 shadow-soft',
        'transition-all duration-200 hover:-translate-y-0.5 hover:border-brand-200 hover:shadow-card',
      )}
    >
      <span
        aria-hidden="true"
        className="flex size-11 items-center justify-center rounded-2xl bg-brand-50 text-brand-600 ring-1 ring-brand-100 transition-colors group-hover:bg-brand-500 group-hover:text-white group-hover:ring-brand-500"
      >
        <ModuleIcon name={categoria.icono_web} className="size-5.5" />
      </span>

      <h3 className="mt-4 text-base font-semibold tracking-tight text-ink-900">{categoria.nombre}</h3>

      <p className="mt-1 line-clamp-2 flex-1 text-sm leading-relaxed text-ink-500">
        {categoria.descripcion ?? 'Módulos disponibles de esta categoría.'}
      </p>

      <span className="mt-4 flex items-center justify-between border-t border-ink-100 pt-3 text-sm">
        <span className="font-medium text-ink-400">
          {categoria.total_modulos} {categoria.total_modulos === 1 ? 'módulo' : 'módulos'}
        </span>

        <span className="flex items-center gap-1 font-semibold text-brand-600">
          Ver módulos
          <ArrowRight
            aria-hidden="true"
            className="size-4 transition-transform group-hover:translate-x-0.5"
          />
        </span>
      </span>
    </Link>
  );
}
